import { Table } from 'antd';
import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { DAYTIME_FORMAT } from '../../constants';

export default function AdminUsersTable({ withAction, dataSource, selectedRowKeys, onSelectChange, ...props }) {
  const { t: tc } = useTranslation('common');
  const columns = [
    {
      title: tc('name'),
      dataIndex: 'name',
      key: 'name',
      fixed: 'left',
      className: 'border-right',
    },
    {
      title: tc('email'),
      dataIndex: 'email',
      key: 'email',
      width: 250,
    },
    {
      title: tc('updatedAt'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 250,
      render: (value) => {
        return value ? moment(value).format(DAYTIME_FORMAT) : '';
      },
    },
    {
      title: tc('createdAt'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 200,
      render: (value) => {
        return value ? moment(value).format(DAYTIME_FORMAT) : '';
      },
    },
  ];

  if (withAction) {
    columns.push({
      key: 'action',
      width: 120,
      className: 'border-left',
      fixed: 'right',
      render(record) {
        return withAction(record);
      },
    });
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <div className="table-job-orders table-common">
      <Table
        columns={columns}
        rowSelection={rowSelection}
        dataSource={dataSource}
        rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-dark' : 'table-row-light')}
        {...props}
      />
    </div>
  );
}
